<div class="card" style="margin-top: 40px;">
    <div class="card-header">Information</div>
    <div class="card-body">
      <div class="container-fluid" style="overflow-y: auto;" id="information">
        Trafikverkets tjäldjupssystem består av ett nätverk av cirka 55st tjälstavar, datainsamling och presentation via webbsida. Historisk mätdatat sparas även för intressenter som är i behov av längre tidsserier.
        <br />
        <br />
        <i>Varför mäta tjäle?</i>
        <br />
        Tjäle uppstår när vattnet i marken fryser till is vilket förändrar markens eller vägens egenskaper. Inom vägsammanhang kan vägar skadas genom tjällyftning som uppkommer när vägkroppen fryser och expanderar vilket kan orsaka sprickbildning i vägens slitlager. Ett vanligt problem på grusvägar är tjällossning som uppstår när det övre lagret av vägen tinar och mjuknar samtidigt som vattnet inte kan transporteras ned i vägkroppen på grund av att den är frusen på djupet. Genom att mäta tjäldjupet kan man uppskatta var och när det är störst risk för tjällossning och begränsa tung trafik under dessa perioder. Tjällossning kan observeras i tjäldjupssystemet genom att notera tidpunkten för när vägens övre del tinar samtidigt som vägen är frusen på djupet.
        <br />
        Exempel:
        <br />
        <img src="/assets/images/info1.png">
        <br />
        <br />
        <i>Hur mäter Trafikverket tjäle?</i><br />
        Trafikverket mäter tjäle med hjälp av tjälstavar som mäter temperaturen på flera nivåer ned till ett par meters djup för att på så sätt bilda en temperaturprofil. Tjälstaven sitter monterad i vägbanan som plogas under vintertid. Data sänds fler gånger per dygn till Trafikverkets IT-miljö för presentation.
        <br />
        <img src="/assets/images/info2.png">
        <br />
        <br />
        <i>Kontakt och frågor</i><br />
        Vid frågor om driftstörningar ska du vända dig till Trafikverkets Användarstöd IT på telefon 010-125 10 10. För kommentarer och önskemål om tjäldjupsmätningarna kontakta vvisarenden&#64;trafikverket.se
      </div>
    </div>   
  </div>
